import {
  CommonStatusStep,
  IAPIServicesApproveItem,
} from '../../../model/api-modules';

export enum ApplyServiceStatus {
  Pending,
  Resolve,
  Reject,
  Processing,
  OrderLoading,
}

const ApplyServiceStatusTextMap = {
  [ApplyServiceStatus.Pending]: '待审批',
  [ApplyServiceStatus.Resolve]: '已开通',
  [ApplyServiceStatus.Reject]: '已驳回',
  [ApplyServiceStatus.Processing]: '开通中',
  [ApplyServiceStatus.OrderLoading]: '待确认',
};

export const getServiceStatusLabel = (status: ApplyServiceStatus) => {
  const applyStatus: ApplyServiceStatus = status;
  let statusDotColor = '';
  switch (applyStatus.toString()) {
    case ApplyServiceStatus.Reject.toString():
      statusDotColor = 'rgb(187, 187, 187)';
      break;
    case ApplyServiceStatus.Resolve.toString():
      statusDotColor = 'rgb(29, 171, 48)';
      break;
    case ApplyServiceStatus.Processing.toString():
      statusDotColor = 'rgb(14, 127, 240)';
      break;
    default:
      statusDotColor = '#f77e45';
  }

  return (
    <div className="status-box webkit-box ">
      <span
        className="status-dot"
        style={{ backgroundColor: statusDotColor }}
      ></span>
      {ApplyServiceStatusTextMap[applyStatus] || ''}
    </div>
  );
};

export const getFormatServiceStatus = (
  status: ApplyServiceStatus,
  record: IAPIServicesApproveItem
) => {
  let applyStatus: ApplyServiceStatus = status;
  if (
    status === ApplyServiceStatus.Pending &&
    record.Deployed === CommonStatusStep.Resolve
  ) {
    applyStatus = ApplyServiceStatus.Processing;
  }
  if (
    status === ApplyServiceStatus.Pending &&
    record.FeeOrderApproved === CommonStatusStep.Pending
  ) {
    applyStatus = ApplyServiceStatus.OrderLoading;
  }
  return applyStatus;
};

export const getApplyServiceStatusOptions = () =>
  [
    ApplyServiceStatus.Pending,
    ApplyServiceStatus.Processing,
    ApplyServiceStatus.Resolve,
    ApplyServiceStatus.Reject,
  ].map((key) => {
    const statusKey = key as any;
    return {
      label: getServiceStatusLabel(statusKey),
      value: key,
    };
  });
